/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */
//入口
import { taxPayment } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

//初始化
export let example = new TableRenderClass({ fields, search });

/*主页面入口*/
export const main = [
  {
    name: '完税证明',
    childMenu: [
      example.createPart({
        name: '完税证明',
        search: ['fws', 'monthrange'],
        list: taxPayment.list,
        requestNow: true,
        fields: [
          'index',
          'fws',
          'wsqy',
          'qyNo',
          'month',
          'startDate',
          'endDate',
          'wsCount',
          'uploadDt',
          'operation'
        ]
      })
    ]
  }
];
